import React from 'react';
import { Redirect } from 'react-router-dom';
import './home.css'
import callApi from '../../../util/apiCaller';

class  HomePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            userCount: 0,
            expertCount: 0,
            workshopCount: 0,
            pageNum: 1,
            pageSize: 25,
            qtext: '',
            isLoading: false
        };

    }
    handleResponse = (response) => {
        return response.data
    }


    fetchListItems = (filters, modal_name, next) => {
        callApi(`v2/${modal_name}s/list`, 'POST', filters).then(res => {
            return next(null, res);
        }).catch(err => {
            return next(err);
        });
    };


    //get the user with a particular id
    componentDidMount() {
        if(window.localStorage.getItem("user")){
            const user = JSON.parse(window.localStorage.getItem("user"))
            callApi(`auth/profile/${user.data._id}`, 'get')
            .then((res) => {
                if(res.user){
                    console.log(res.user)
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            user: res.user
                        }
                    })
                }
            })
            .catch((error) => console.log(error.message))


            // fetch the number of users, experts, workshops ------
            let filters = {
                pageNum: this.state.pageNum,
                pageSize: this.state.pageSize,
                qtext: this.state.qtext
            };
            this.setState({isLoading: true});


            // fetch the number of users
            this.fetchListItems(filters, "user", (err, res) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(res)
                    this.setState({
                        // users: res.data['users'] ? res.data['users'] : [],
                        userCount: res.data.count ? res.data.count : 0,
                        // isRefreshing: false,
                        // isLoading: false,
                        // isSearching: false
                    }, () => console.log(this.state));
                }
            });

            // fetch the number of experts
            this.fetchListItems(filters, "expert", (err, res) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(res)
                    this.setState({
                        // items: res.data[MODEL_NAME + 's'] ? res.data[MODEL_NAME + 's'] : [],
                        expertCount: res.data.count ? res.data.count : 0,
                        // isRefreshing: false,
                        // isLoading: false,
                        // isSearching: false
                    }, () => console.log(this.state));
                }
            });

            // fetch the number of workshops
            this.fetchListItems(filters, "workshop", (err, res) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(res)
                    this.setState({
                        // items: res.data[MODEL_NAME + 's'] ? res.data[MODEL_NAME + 's'] : [],
                        workshopCount: res.data.count ? res.data.count : 0,
                        // isRefreshing: false,
                        isLoading: false,
                        // isSearching: false
                    }, () => console.log(this.state));
                }
            });
        }else{
            // alert("No data found")
        }
            
    }

    

    render() {
        const { user } = this.state;
        return (
            <>
                { this.props.isAuthenticated ?
                <div>
                {/* <Header/> */}
                    <div className="home_page_sec" style={{marginLeft:this.props.showSidebar? "240px":"70px", minHeight: "100vh"}}> 
                        <div className="home_page">
                        <div className="row">
                            {/* <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Dashboard - {user?.name}</h4>
                                <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a>Nazox</a></li>
                                    <li className="breadcrumb-item active">Dashboard</li>
                                </ol>
                                </div>
                            </div>
                            </div> */}
                        </div>  
                           <div className="row mt-4">
                             <div className="col-xl-8">
                              <div className="row">
                                <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                    <div className="media">
                                        <div className="media-body overflow-hidden">
                                        <p className="text-truncate font-size-14 mb-2">Number of Users</p>
                                        <h4 className="mb-0">{this.state.userCount}</h4>
                                        </div>
                                        <div className="text-primary">
                                        <i className="ri-stack-line font-size-24" />
                                        </div>
                                    </div>
                                    </div>
                                    {/* <div className="card-body border-top py-3">
                                    <div className="text-truncate">
                                        <span className="badge badge-soft-success font-size-11"><i className="mdi mdi-menu-up"> </i> 10 </span>
                                        <span className="text-muted ml-2">From previous period</span>
                                    </div>
                                    </div> */}
                                </div>
                                </div>
                                {/* 1st-card-end */}
                                <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                    <div className="media">
                                        <div className="media-body overflow-hidden">
                                        <p className="text-truncate font-size-14 mb-2">Number of Experts</p>
                                        <h4 className="mb-0">{this.state.expertCount}</h4>
                                        </div>
                                        <div className="text-primary">
                                        <i className="ri-store-2-line font-size-24" />
                                        </div>
                                    </div>
                                    </div>
                                    {/* <div className="card-body border-top py-3">
                                    <div className="text-truncate">
                                        <span className="badge badge-soft-success font-size-11"><i className="mdi mdi-menu-up"> </i> 2 </span>
                                        <span className="text-muted ml-2">From previous period</span>
                                    </div>
                                    </div> */}
                                </div>
                                </div>
                                {/* 2nd-card-end */}
                                <div className="col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                    <div className="media">
                                        <div className="media-body overflow-hidden">
                                        <p className="text-truncate font-size-14 mb-2">Number of Workshops</p>
                                        <h4 className="mb-0">{this.state.workshopCount}</h4>
                                        </div>
                                        <div className="text-primary">
                                        <i className="ri-briefcase-4-line font-size-24" />
                                        </div>
                                    </div>
                                    </div>
                                    {/* <div className="card-body border-top py-3">
                                    <div className="text-truncate">
                                        <span className="badge badge-soft-success font-size-11"><i className="mdi mdi-menu-up"> </i> 1 </span>
                                        <span className="text-muted ml-2">From previous period</span>
                                    </div>
                                    </div> */}
                                </div>
                                </div>
                              </div>
                              {/* cards-end */}
                              <div className="card" style={{padding:"20px 0px"}}>
                                    <div className="card-body">
                                    <div className="float-right d-none d-md-inline-block">
                                        <div className="btn-group mb-2">
                                        <button type="button" className="btn btn-sm btn-light">Today</button>
                                        <button type="button" className="btn btn-sm btn-light active">Weekly</button>
                                        <button type="button" className="btn btn-sm btn-light">Monthly</button>
                                        </div>
                                    </div>
                                    <h4 className="card-title mb-4">Revenue Analytics</h4>
                                    </div>
                                    <div className="card-body border-top text-center">
                                    <div className="row">
                                        <div className="col-sm-4">
                                        <div className="d-inline-flex">
                                            <h5 className="mr-2">$12,253</h5>
                                            <div className="text-success">
                                            <i className="mdi mdi-menu-up font-size-14"> </i>2.2 %
                                            </div>
                                        </div>
                                        <p className="text-muted text-truncate mb-0">This month</p>
                                        </div>
                                        <div className="col-sm-4">
                                        <div className="mt-4 mt-sm-0">
                                            <p className="mb-2 text-muted text-truncate"><i className="mdi mdi-circle text-primary font-size-10 mr-1" /> This Year :</p>
                                            <div className="d-inline-flex">
                                            <h5 className="mb-0 mr-2">$ 34,254</h5>
                                            <div className="text-success">
                                                <i className="mdi mdi-menu-up font-size-14"> </i>2.1 %
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-sm-4">
                                        <div className="mt-4 mt-sm-0">
                                            <p className="mb-2 text-muted text-truncate"><i className="mdi mdi-circle text-success font-size-10 mr-1" /> Previous Year :</p>
                                            <div className="d-inline-flex">
                                            <h5 className="mb-0">$ 32,695</h5>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                             </div>
                             <div className="col-xl-4">
                             <div className="card" style={{height:"343px"}}>
                            <div className="card-body" style={{position: 'relative'}}>
                            <div className="float-right">
                                <select className="custom-select custom-select-sm">
                                <option selected>Apr</option>
                                <option value={1}>Mar</option>
                                <option value={2}>Feb</option>
                                <option value={3}>Jan</option>
                                </select>
                            </div>
                            <h4 className="card-title mb-4">Sales Analytics</h4>
                            <div id="donut-chart" className="apex-charts" style={{minHeight: '230.7px',position:"relative",left:"5px"}}><div id="apexcharts31mlml8c" className="apexcharts-canvas apexcharts31mlml8c apexcharts-theme-light" style={{width: '298px', height: '230.7px'}}><svg id="SvgjsSvg1113"  width={298} height="230.70000000000002" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns svgjs="http://svgjs.com/svgjs" className="apexcharts-svg" xmlns data="ApexChartsNS" transform="translate(0, 0)" style={{background: 'transparent'}}><g id="SvgjsG1115" className="apexcharts-inner apexcharts-graphical" transform="translate(47, 0)"><defs id="SvgjsDefs1114"><clipPath id="gridRectMask31mlml8c"><rect id="SvgjsRect1117" width={212} height={230} x={-3} y={-1} rx={0} ry={0} opacity={1} strokeWidth={0} stroke="none" strokeDasharray={0} fill="#fff" /></clipPath><clipPath id="gridRectMarkerMask31mlml8c"><rect id="SvgjsRect1118" width={210} height={232} x={-2} y={-2} rx={0} ry={0} opacity={1} strokeWidth={0} stroke="none" strokeDasharray={0} fill="#fff" /></clipPath></defs><g id="SvgjsG1120" className="apexcharts-pie"><g id="SvgjsG1121" transform="translate(0, 0) scale(1)"><circle id="SvgjsCircle1122" r="78.91463414634148" cx={103} cy={114} fill="transparent" /><g id="SvgjsG1123" className="apexcharts-slices"><g id="SvgjsG1124" className="apexcharts-series apexcharts-pie-series" seriesname="ProductxA" rel={1} data realindex={0}><path id="SvgjsPath1125" d="M 103 8.780487804878035 A 105.21951219512196 105.21951219512196 0 1 1 99.01833827902367 219.14414922628424 L 100.01375370926776 192.85811191971322 A 78.91463414634148 78.91463414634148 0 1 0 103 35.085365853658516 L 103 8.780487804878035 z" fill="rgba(86,100,210,1)" fillOpacity={1} strokeOpacity={1} strokeLinecap="butt" strokeWidth={2} strokeDasharray={0} className="apexcharts-pie-area apexcharts-donut-slice-0" index={0} j={0} data angle="182.16867469879517" data startangle={0} data strokewidth={2} data value={42} data pathorig="M 103 8.780487804878035 A 105.21951219512196 105.21951219512196 0 1 1 99.01833827902367 219.14414922628424 L 100.01375370926776 192.85811191971322 A 78.91463414634148 78.91463414634148 0 1 0 103 35.085365853658516 L 103 8.780487804878035 z" stroke="#ffffff" /></g><g id="SvgjsG1126" className="apexcharts-series apexcharts-pie-series" seriesname="ProductxB" rel={2} data realindex={1}><path id="SvgjsPath1127" d="M 99.01833827902367 219.14414922628424 A 105.21951219512196 105.21951219512196 0 0 1 7.592035999296513 69.6326003486807 L 31.444026999472385 80.72445026151053 A 78.91463414634148 78.91463414634148 0 0 0 100.01375370926776 192.85811191971322 L 99.01833827902367 219.14414922628424 z" fill="rgba(28,187,140,1)" fillOpacity={1} strokeOpacity={1} strokeLinecap="butt" strokeWidth={2} strokeDasharray={0} className="apexcharts-pie-area apexcharts-donut-slice-1" index={0} j={1} data angle="112.77108433734938" data startangle="182.16867469879517" data strokewidth={2} data value={26} data pathorig="M 99.01833827902367 219.14414922628424 A 105.21951219512196 105.21951219512196 0 0 1 7.592035999296513 69.6326003486807 L 31.444026999472385 80.72445026151053 A 78.91463414634148 78.91463414634148 0 0 0 100.01375370926776 192.85811191971322 L 99.01833827902367 219.14414922628424 z" stroke="#ffffff" /></g><g id="SvgjsG1128" className="apexcharts-series apexcharts-pie-series" seriesname="ProductxC" rel={3} data realindex={2}><path id="SvgjsPath1129" d="M 7.592035999296513 69.6326003486807 A 105.21951219512196 105.21951219512196 0 0 1 102.98163573084175 8.780489407462838 L 102.98622679813131 35.08536705559712 A 78.91463414634148 78.91463414634148 0 0 0 31.444026999472385 80.72445026151053 L 7.592035999296513 69.6326003486807 z" fill="rgba(238,185,2,1)" fillOpacity={1} strokeOpacity={1} strokeLinecap="butt" strokeWidth={2} strokeDasharray={0} className="apexcharts-pie-area apexcharts-donut-slice-2" index={0} j={2} data angle="65.06024096385545" data startangle="294.93975903614455" data strokewidth={2} data value={15} data pathorig="M 7.592035999296513 69.6326003486807 A 105.21951219512196 105.21951219512196 0 0 1 102.98163573084175 8.780489407462838 L 102.98622679813131 35.08536705559712 A 78.91463414634148 78.91463414634148 0 0 0 31.444026999472385 80.72445026151053 L 7.592035999296513 69.6326003486807 z" stroke="#ffffff" /></g></g></g></g></g><g id="SvgjsG1116" className="apexcharts-annotations" /></svg><div className="apexcharts-legend" /><div className="apexcharts-tooltip apexcharts-theme-dark" style={{left: '27.5156px', top: '101px'}}><div className="apexcharts-tooltip-series-group apexcharts-active" style={{display: 'flex', backgroundColor: 'rgb(28, 187, 140)'}}><span className="apexcharts-tooltip-marker" style={{backgroundColor: 'rgb(28, 187, 140)', display: 'none'}} /><div className="apexcharts-tooltip-text" style={{fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px'}}><div className="apexcharts-tooltip-z-group"><span className="apexcharts-tooltip-text-z-label" /><span className="apexcharts-tooltip-text-z-value" /></div></div></div><div className="apexcharts-tooltip-series-group" style={{display: 'none', backgroundColor: 'rgb(28, 187, 140)'}}><span className="apexcharts-tooltip-marker" style={{backgroundColor: 'rgb(28, 187, 140)', display: 'none'}} /><div className="apexcharts-tooltip-text" style={{fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px'}}><div className="apexcharts-tooltip-y-group"><span className="apexcharts-tooltip-text-label">Product B: </span><span className="apexcharts-tooltip-text-value">26</span></div><div className="apexcharts-tooltip-z-group"><span className="apexcharts-tooltip-text-z-label" /><span className="apexcharts-tooltip-text-z-value" /></div></div></div><div className="apexcharts-tooltip-series-group" style={{display: 'none', backgroundColor: 'rgb(28, 187, 140)'}}><span className="apexcharts-tooltip-marker" style={{backgroundColor: 'rgb(28, 187, 140)', display: 'none'}} /><div className="apexcharts-tooltip-text" style={{fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px'}}><div className="apexcharts-tooltip-y-group"><span className="apexcharts-tooltip-text-label">Product B: </span><span className="apexcharts-tooltip-text-value">26</span></div><div className="apexcharts-tooltip-z-group"><span className="apexcharts-tooltip-text-z-label" /><span className="apexcharts-tooltip-text-z-value" /></div></div></div></div></div></div>
                            {/* <div className="row">
                                <div className="col-4">
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-primary font-size-10 mr-1" /> Product A</p>
                                    <h5>42 %</h5>
                                </div>
                                </div>
                                <div className="col-4">
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-success font-size-10 mr-1" /> Product B</p>
                                    <h5>26 %</h5>
                                </div>
                                </div>
                                <div className="col-4">
                                <div className="text-center mt-4">
                                    <p className="mb-2 text-truncate"><i className="mdi mdi-circle text-warning font-size-10 mr-1" /> Product C</p>
                                    <h5>42 %</h5>
                                </div>
                                </div>
                            </div> */}
                           </div>
                        </div>

                             </div>
                           </div>
                           


                           {/* <div className="row">
                           <div className="col-lg-4">
                            <div className="card">
                            <div className="card-body">
                                <div className="dropdown float-right">
                                <a href="#" className="dropdown-toggle arrow-none card-drop" data-toggle="dropdown" aria-expanded="false">
                                    <i className="mdi mdi-dots-vertical" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Sales Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Export Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Profit</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Action</a>
                                </div>
                                </div>
                                <h4 className="card-title mb-4">Recent Activity Feed</h4>
                                <div data-simplebar="init" style={{maxHeight: '330px'}} className><div className="simplebar-wrapper" style={{margin: '0px'}}><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer" /></div><div className="simplebar-mask"><div className="simplebar-offset" style={{right: '-17px', bottom: '0px'}}><div className="simplebar-content-wrapper" style={{height: 'auto', overflow: 'hidden scroll'}}><div className="simplebar-content" style={{padding: '0px'}}>
                                            <ul className="list-unstyled activity-wid">
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-edit-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">28 Apr, 2020 <small className="text-muted">12:07 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-user-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">21 Apr, 2020 <small className="text-muted">08:01 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Added an interest “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-bar-chart-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">17 Apr, 2020 <small className="text-muted">09:23 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Joined the group “Boardsmanship Forum”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-mail-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">11 Apr, 2020 <small className="text-muted">05:10 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “In-Kind Opportunity”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-calendar-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">07 Apr, 2020 <small className="text-muted">12:47 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Created need “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-edit-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">05 Apr, 2020 <small className="text-muted">03:09 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Attending the event “Some New Event”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-user-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">02 Apr, 2020 <small className="text-muted">12:07 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “In-Kind Opportunity”</p>
                                                </div>
                                                </div>
                                            </li>
                                            </ul>
                                                </div></div></div></div><div className="simplebar-placeholder" style={{width: 'auto', height: '698px'}} /></div><div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}><div className="simplebar-scrollbar" style={{transform: 'translate3d(0px, 0px, 0px)', display: 'none'}} /></div><div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}><div className="simplebar-scrollbar" style={{height: '156px', transform: 'translate3d(0px, 0px, 0px)', display: 'block'}} /></div></div>
                                                        </div>
                                                </div>
                        </div>
                        


                        <div className="col-lg-4">
                            <div className="card">
                            <div className="card-body">
                                <div className="dropdown float-right">
                                <a href="#" className="dropdown-toggle arrow-none card-drop" data-toggle="dropdown" aria-expanded="false">
                                    <i className="mdi mdi-dots-vertical" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Sales Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Export Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Profit</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Action</a>
                                </div>
                                </div>
                                <h4 className="card-title mb-4">Revenue by Locations</h4>
                                
                                <div className="row justify-content-center">
                                <div className="col-xl-5 col-md-6">
                                    <div className="mt-2">
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2542</h5>
                                        <p className="text-muted mb-0 text-truncate">California :</p>
                                    </div>
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2245</h5>
                                        <p className="text-muted mb-0 text-truncate">Nevada :</p>
                                    </div>
                                    </div>
                                </div>
                                <div className="col-xl-5 offset-xl-1 col-md-6">
                                    <div className="mt-2">
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2156</h5>
                                        <p className="text-muted mb-0 text-truncate">Montana :</p>
                                    </div>
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 1845</h5>
                                        <p className="text-muted mb-0 text-truncate">Texas :</p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div className="text-center mt-4">
                                <a href="#" className="btn btn-primary btn-sm">Learn more</a>
                                </div>
                            </div>
                            </div>
                            


                            <div className="card">
                            <div className="card-body">
                                <div className="dropdown float-right">
                                <a href="#" className="dropdown-toggle arrow-none card-drop" data-toggle="dropdown" aria-expanded="false">
                                    <i className="mdi mdi-dots-vertical" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Sales Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Export Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Profit</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Action</a>
                                </div>
                                </div>
                                <h4 className="card-title mb-4">Revenue by Locations</h4>
                                
                                <div className="row justify-content-center">
                                <div className="col-xl-5 col-md-6">
                                    <div className="mt-2">
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2542</h5>
                                        <p className="text-muted mb-0 text-truncate">California :</p>
                                    </div>
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2245</h5>
                                        <p className="text-muted mb-0 text-truncate">Nevada :</p>
                                    </div>
                                    </div>
                                </div>
                                <div className="col-xl-5 offset-xl-1 col-md-6">
                                    <div className="mt-2">
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 2156</h5>
                                        <p className="text-muted mb-0 text-truncate">Montana :</p>
                                    </div>
                                    <div className="clearfix py-2">
                                        <h5 className="float-right font-size-16 m-0">$ 1845</h5>
                                        <p className="text-muted mb-0 text-truncate">Texas :</p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                               
                            </div>
                            </div>
                        </div>
                        


                        <div className="col-lg-4">
                            <div className="card">
                            <div className="card-body">
                                <div className="dropdown float-right">
                                <a href="#" className="dropdown-toggle arrow-none card-drop" data-toggle="dropdown" aria-expanded="false">
                                    <i className="mdi mdi-dots-vertical" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Sales Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Export Report</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Profit</a>
                                    
                                    <a href="javascript:void(0);" className="dropdown-item">Action</a>
                                </div>
                                </div>
                                <h4 className="card-title mb-4">Recent Activity Feed</h4>
                                <div data-simplebar="init" style={{maxHeight: '330px'}} className><div className="simplebar-wrapper" style={{margin: '0px'}}><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer" /></div><div className="simplebar-mask"><div className="simplebar-offset" style={{right: '-17px', bottom: '0px'}}><div className="simplebar-content-wrapper" style={{height: 'auto', overflow: 'hidden scroll'}}><div className="simplebar-content" style={{padding: '0px'}}>
                                            <ul className="list-unstyled activity-wid">
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-edit-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">28 Apr, 2020 <small className="text-muted">12:07 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-user-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">21 Apr, 2020 <small className="text-muted">08:01 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Added an interest “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-bar-chart-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">17 Apr, 2020 <small className="text-muted">09:23 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Joined the group “Boardsmanship Forum”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-mail-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">11 Apr, 2020 <small className="text-muted">05:10 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “In-Kind Opportunity”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-calendar-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">07 Apr, 2020 <small className="text-muted">12:47 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Created need “Volunteer Activities”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-edit-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">05 Apr, 2020 <small className="text-muted">03:09 pm</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Attending the event “Some New Event”</p>
                                                </div>
                                                </div>
                                            </li>
                                            <li className="activity-list">
                                                <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className="ri-user-2-fill" />
                                                </span>
                                                </div>
                                                <div>
                                                <div>
                                                    <h5 className="font-size-13">02 Apr, 2020 <small className="text-muted">12:07 am</small></h5>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0">Responded to need “In-Kind Opportunity”</p>
                                                </div>
                                                </div>
                                            </li>
                                            </ul>
                                                </div></div></div></div><div className="simplebar-placeholder" style={{width: 'auto', height: '698px'}} /></div><div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}><div className="simplebar-scrollbar" style={{transform: 'translate3d(0px, 0px, 0px)', display: 'none'}} /></div><div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}><div className="simplebar-scrollbar" style={{height: '156px', transform: 'translate3d(0px, 0px, 0px)', display: 'block'}} /></div></div>
                                                        </div>
                                                </div>
                        </div>
                           </div>
                        </div> */}
                       
      
                    </div>

                   </div>
                </div>
            :  (
               
                <>
              
                    {<Redirect to="/login" />}
                </>
                )
            }
        </>
            
        );
    }
}

export default HomePage;

